module.exports = __webpack_public_path__ + "static/media/earnings.3b512373.png";